<template>
  <div class="flex-col">
    <div class="uppercase mb-4">
      {{ option.label }}
    </div>
    <div @click="toggleSelect" class="flex justify-center select-none cursor-pointer">
      <div v-if="selected" class="w-8 h-8">
        <CheckmarkIcon></CheckmarkIcon>
      </div>
      <div v-else class="rounded-full border border-black h-8 w-8">
        &nbsp;
      </div>
    </div>
  </div>
</template>

<script>
import CheckmarkIcon from '@/components/CheckmarkIcon'

export default {
  name: 'RadioSelector',
  props: ['option'],
  components: { CheckmarkIcon },
  data () {
    return {
      name: this.option.name,
      selected: false
    }
  },
  methods: {
    getValue () {
      return {
        label: this.option.label,
        name: this.option.name,
        price: this.option.price
      }
    },
    isSelected () {
      return this.selected
    },
    toggleSelect () {
      this.selected = !this.selected
      this.$emit('click')
    },
    setSelect (selected) {
      this.selected = selected
    },
    reset () {
      this.selected = false
    }
  }
}
</script>
